import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AiAgentModel} from "../../../models/ai-agent.model";

require('./ai-agents-table.scss');
@Component({
  standalone: false,
  selector: 'app-ai-agents-table',
  templateUrl: './ai-agents-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiAgentsTableComponent implements OnInit, OnChanges {

  @Input() aiAgents: AiAgentModel[];
  @Input() allowEdit: boolean;
  @Input() allowDelete: boolean;

  @Output() reloadEvent = new EventEmitter<any>();
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() editAiAgentEvent = new EventEmitter<AiAgentModel>();
  @Output() deleteAiAgentEvent = new EventEmitter<AiAgentModel>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public currentLastRowIndex: number;
  public asceDescIconsMap: any;

  constructor() {
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.aiAgents && this.aiAgents && this.aiAgents.length) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }


}
